<template>
  <div class="header-left-menu">
    <ul>
      <li>
        <a
          class="btn"
          href="#"
          @click.prevent="showLocationMenu = !showLocationMenu"
          >{{ $t("lang.header.menu_title_1") }}<i class="fa fa-angle-down"></i
        ></a>

        <div
          v-if="showLocationMenu"
          :class="`header-form ${showLocationMenu ? 'open' : ''}`"
          v-click-outside="onClickOutside"
        >
          <div class="row">
            <div class="col-3 pr-0">
              <div class="form-nav">
                <ul class="nav nav-tabs">
                  <li>
                    <a
                      class="active"
                      v-if="role === 1"
                      data-toggle="tab"
                      href="#companies"
                      >{{ $t("lang.header.location_menu.menu_title_1") }}</a
                    >
                  </li>
                  <li>
                    <a
                      data-toggle="tab"
                      v-if="role === 1 || role === 2"
                      href="#brand"
                      >{{ $t("lang.header.location_menu.menu_title_2") }}</a
                    >
                  </li>
                  <li>
                    <a data-toggle="tab" href="#location">{{
                      $t("lang.header.location_menu.menu_title_3")
                    }}</a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#store">{{
                      $t("lang.header.location_menu.menu_title_4")
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-9 pl-0">
              <div class="tab-content">
                <div id="companies" class="search-box tab-pane active">
                  <div class="search-input">
                    <input
                      :placeholder="
                        $t('lang.header.location_menu.search_placeholder_1')
                      "
                      type="search"
                    />
                    <i class="fa fa-search"></i>
                  </div>
                  <ul class="content-list" v-if="companies">
                    <li v-for="company in companies" :key="company.id">
                      {{ company.name }}
                    </li>
                  </ul>
                </div>
                <div id="brand" class="search-box tab-pane">
                  <span
                    class="left-arrow"
                    @click.prevent="nextPrevBrand(brands.previous)"
                  >
                    <i class="fa fa-angle-left"></i>
                  </span>
                  <div class="search-input">
                    <input
                      :placeholder="
                        $t('lang.header.location_menu.search_placeholder_2')
                      "
                      @input="inputBrand"
                      type="search"
                    />
                    <i class="fa fa-search"></i>
                  </div>
                  <ul class="content-list" v-if="brands">
                    <li
                      v-for="brand in brands.results"
                      style="cursor: pointer"
                      :key="brand.id"
                      @click="selectBrand(brand)"
                    >
                      {{ brand.description }}
                    </li>
                  </ul>
                  <span
                    class="right-arrow"
                    @click.prevent="nextPrevBrand(brands.next)"
                  >
                    <i class="fa fa-angle-right"></i>
                  </span>
                </div>
                <div id="location" class="search-box tab-pane">
                  <span
                    class="left-arrow"
                    @click.prevent="nextPrevLocation(locations.previous)"
                  >
                    <i class="fa fa-angle-left"></i>
                  </span>
                  <div class="search-input">
                    <input
                      :placeholder="
                        $t('lang.header.location_menu.search_placeholder_3')
                      "
                      @input="inputLocation"
                      type="search"
                    />
                    <i class="fa fa-search"></i>
                  </div>
                  <ul class="content-list" v-if="locations">
                    <li
                      style="cursor: pointer"
                      @click="selectLocation(location)"
                      v-for="location in locations.results"
                      :key="location.id"
                    >
                      {{ location.description }}
                    </li>
                  </ul>
                  <span
                    class="right-arrow"
                    @click.prevent="nextPrevLocation(locations.next)"
                  >
                    <i class="fa fa-angle-right"></i>
                  </span>
                </div>
                <div id="store" class="search-box tab-pane">
                  <div class="search-input">
                    <input
                      :placeholder="
                        $t('lang.header.location_menu.search_placeholder_4')
                      "
                      type="search"
                    />
                    <i class="fa fa-search"></i>
                  </div>
                  <ul class="content-list" v-if="stores">
                    <li
                      v-for="store in stores"
                      style="cursor: pointer"
                      @click="selectLocation(store)"
                      :key="store.id"
                    >
                      {{ store.description }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <a class="btn px-2" href="/alarm">
          <!-- {{ $t("lang.header.menu_title_2") }} -->
          <v-icon class="mx-0" color="#27372F" size="24">
            mdi-bell-outline
          </v-icon>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WebHeaderLocationMenu",
  data() {
    return {
      showLocationMenu: false,
      companies: null,
      brands: null,
      locations: null,
      stores: null,
      options: {
        limit: 12
      },
      offsetLocations: 0
    };
  },
  mounted() {
    this.getCompany();
    this.getBrands();
    this.getLocations();
    this.getStores();
  },
  computed: {
    role: function() {
      return this.$store.state.user.role;
    },
    brandMenu: {
      get() {
        return this.$store.getters.brandMenu;
      },
      set(data) {
        this.$store.dispatch("setBrandMenu", data);
      }
    },
    showSideMenu: {
      get() {
        return this.$store.getters.showSideMenu;
      },
      set(data) {
        this.$store.dispatch("setSideMenu", data);
      }
    },
    brand: {
      get() {
        return this.$store.getters.brand;
      },
      set(data) {
        this.$store.dispatch("setBrand", data);
      }
    }
  },
  methods: {
    onClickOutside() {
      if (this.showLocationMenu) {
        this.showLocationMenu = false;
      }
    },
    async getLocations() {
      this.locations = await this.$api.location.search("", {
        limit: this.options.limit,
        offset: this.offsetLocations
      });
    },
    async getBrands() {
      this.brands = await this.$api.brand.search("", {
        limit: this.options.limit,
        offset: this.offsetLocations
      });
    },
    async getCompany() {
      this.companies = await this.$api.company.list();
    },
    async getStores() {
      this.stores = await this.$api.store.list();
    },
    async inputBrand(e) {
      this.brands = await this.$api.brand.search(e.target.value, {
        limit: this.options.limit,
        offset: this.offsetLocations
      });
    },
    async inputLocation(e) {
      this.locations = await this.$api.location.search(e.target.value, {
        limit: this.options.limit,
        offset: this.offsetLocations
      });
    },
    async nextPrevLocation(paginationUrl) {
      if (paginationUrl) {
        this.locations = await this.$api.location.search("", {
          paginationUrl: paginationUrl
        });
      }
    },
    async nextPrevBrand(paginationUrl) {
      if (paginationUrl) {
        this.brands = await this.$api.brand.search("", {
          paginationUrl: paginationUrl
        });
      }
    },
    selectLocation(location) {
      localStorage.setItem("location", location.description);
      localStorage.setItem("location_id", location.id);
      window.location.href = "/dashboard";
      this.showSideMenu =
        localStorage.getItem("dashboard_type") || "dashboard_menu";
      this.brandMenu = false;
      this.showLocationMenu = false;
    },
    async selectBrand(brand) {
      this.brand = brand;
      this.brandMenu = true;
      this.showSideMenu =
        localStorage.getItem("dashboard_type") || "dashboard_menu";
      window.location.href = "/brand/dashboard";
      this.showLocationMenu = false;
    }
  }
};
</script>

<style></style>
